import styled from "styled-components";

const StyledTd = styled.td`
  padding: 1rem 2rem;
`;

export default StyledTd;
